import { HttpClient, HttpContext } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { QueryParams0202DTO, ResultatsCalculDTO, ResultatsCalculDTOSchema } from "@mra/hlp9002";
import { Observable } from "rxjs";
import { environment } from "../../../../environments/environment";
import { VALIDATION_SCHEMA_CONTEXT } from "../api/http-format-interceptor.service";

@Injectable({
  providedIn: "root"
})
export class RenteCalculService {
  private readonly http = inject(HttpClient);
  private readonly context: HttpContext = new HttpContext().set(VALIDATION_SCHEMA_CONTEXT, ResultatsCalculDTOSchema);

  /**
   * calcul la rente en fonction de la configuration actuellement sélectionnée
   * @param coutOptions si on souhaite le montant de rente avec ou sans option
   * @param options liste des options
   * @param consommationCapital consommation de l'épargne par la sortie en capital
   * @returns résultats de calcul de la rente
   */
  renteCalcul(
    dateEffet: string,
    montantEpargne: number,
    consommationCapital: number,
    coutOptions: boolean = false,
    options: string[] = []
  ): Observable<ResultatsCalculDTO> {
    const msParams: QueryParams0202DTO = {
      coutOptions,
      dateEffet,
      montantEpargne,
      options,
      consommationCapital
    };
    return this.http.get<ResultatsCalculDTO>(environment.urlsMs.MS0202, {
      context: this.context,
      params: msParams
    });
  }
}
